import moment from 'moment';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import VolEventsDuck from 'app/ducks/company-admin/vol-events';
import CadminApi     from 'app/apis/company-admin';
import Link          from 'app/components/common/link';
import Modal         from 'app/components/common/modal';
import StandardInput from 'app/components/common/standard-input';
import ModalChannel  from 'app/components/company-admin/slack/modal-channel';
import config        from 'app/config';
import helpers       from 'app/helpers/slack';
import paths         from 'app/paths';
import CadminSlx     from 'app/selectors/company-admin/';

class ModalSlackChannelEvent extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.onUnlink = this.onUnlink.bind(this);
    this.onClickAnnounce = this.onClickAnnounce.bind(this);
    this.onClickRemind = this.onClickRemind.bind(this);
  }

  onClose() {
    this.props.onClose();
  }

  onCreate(slackChannel) {
    const { company, volEvent, update } = this.props;
    return update(company.id, volEvent.id, {slackChannelId: slackChannel.id}).then(() => {
      const topic = `${volEvent.title} ${config.baseUrl}${paths.volEvent(volEvent.id)}`;
      CadminApi.slackChannelsSetTopic(company.id, slackChannel.id, topic);
    });
  }

  onUnlink(_slackChannelId) {
    const { company, volEvent, update } = this.props;
    return update(company.id, volEvent.id, {slackChannelId: null});
  }

  onClickAnnounce(event) {
    event.target.disabled = true;
    const {volEvent, announce} = this.props;
    announce(volEvent.id);
  }

  onClickRemind(event) {
    event.target.disabled = true;
    const {volEvent, remind} = this.props;
    remind(volEvent.id);
  }

  renderSubHeader() {
    const { volEvent } = this.props;
    return (
      <div className="ca-modal-schannel-subheader">
        <img src={`${config.cdnBaseUrl}/${volEvent.imgPath}`} />
        {volEvent.title}
      </div>
    );
  }

  renderActions() {
    const {company, volEvent} = this.props;
    const announceDisabled = !(company.isSlackSetup && company.mainSlackChannelId);
    const remindDisabled = !volEvent.slackChannelId;
    return (<>
      <div className={`ca-modal-schannel-action ${announceDisabled ? 'disabled' : ''}`}>
        <p>Announce this opportunity in the main Slack channel</p>
        <button onClick={this.onClickAnnounce} className="btn special slack secondary" disabled={announceDisabled}>Post Announcement</button>
      </div>
      <div className={`ca-modal-schannel-action ${remindDisabled ? 'disabled' : ''}`}>
        <p>Post a reminder to the opportunity's Slack channel</p>
        <button onClick={this.onClickRemind} className="btn special slack secondary" disabled={remindDisabled}>Post Reminder</button>
      </div>
    </>);
  }

  render() {
    const { volEvent } = this.props;

    return (
      <ModalChannel
        title="Volunteer Opportunity Settings"
        onClose={this.onClose}
        onCreate={this.onCreate}
        onUnlink={this.onUnlink}
        id={volEvent.slackChannelId}
        subHeader={this.renderSubHeader()}
        defaultName={volEvent.title}
        actions={this.renderActions()}
      />
    );
  }

}

ModalSlackChannelEvent.propTypes = {
  onClose: PropTypes.func.isRequired,
  volEvent: PropTypes.object.isRequired,
};

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
});

const dispatchToProps = (dispatch) => ({
  update: (companyId, volEventId, attrs) => dispatch(VolEventsDuck.Ax.update(companyId, volEventId, attrs)),
  announce: (volEventId) => dispatch(VolEventsDuck.Ax.announceInSlack(undefined, volEventId)),
  remind: (volEventId) => dispatch(VolEventsDuck.Ax.remindInSlack(undefined, volEventId)),
});

export default connect(stateToProps, dispatchToProps)(ModalSlackChannelEvent);
